(function() {
  'use strict';
  
  // Format currency in Japanese Yen
  function formatCurrency(amount) {
    return '¥' + (amount / 100).toLocaleString('ja-JP', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  
  // Update cashback amount when variant/price changes
  function updateCashbackAmount() {
    const cashbackBadge = document.querySelector('.member-cashback-badge');
    if (!cashbackBadge) return;
    
    // Get current variant price from the page
    const priceElement = document.querySelector('.sp-price .new-price, .sp-price .old-price, .sp-price .sale-price');
    if (!priceElement) return;
    
    // Extract price from text (remove currency symbols)
    const priceText = priceElement.textContent.replace(/[^\d,]/g, '').replace(/,/g, '');
    const currentPrice = parseInt(priceText) * 100; // Convert to cents
    
    // Get cashback rate from data attribute
    const cashbackRate = parseInt(cashbackBadge.getAttribute('data-cashback-rate')) || 0;
    
    if (cashbackRate > 0 && currentPrice > 0) {
      // Calculate cashback amount
      const cashbackAmount = Math.floor(currentPrice * cashbackRate / 100);
      
      // Update cashback amount display
      const amountElement = cashbackBadge.querySelector('.cashback-amount-value');
      if (amountElement) {
        amountElement.textContent = formatCurrency(cashbackAmount);
      }
      
      // Update next rank incentive if present
      const nextRankElement = cashbackBadge.querySelector('.cashback-next-rank');
      if (nextRankElement) {
        const currentSpending = parseInt(cashbackBadge.getAttribute('data-current-spending')) || 0;
        const nextRankThreshold = parseInt(cashbackBadge.getAttribute('data-next-rank-threshold')) || 0;
        const nextRank = nextRankElement.getAttribute('data-next-rank');
        const nextRankRate = parseInt(nextRankElement.getAttribute('data-next-rate')) || 0;
        
        if (nextRank && nextRankThreshold > 0) {
          const remainingAmount = Math.max(0, nextRankThreshold - currentSpending);
          
          if (remainingAmount > 0) {
            const nextRankAmountElement = nextRankElement.querySelector('.next-rank-amount');
            const nextRankMessage = nextRankElement.querySelector('.next-rank-message');
            const nextRankBenefit = nextRankElement.querySelector('.next-rank-benefit');
            
            if (nextRankAmountElement) {
              nextRankAmountElement.textContent = formatCurrency(remainingAmount);
            }
            
            if (nextRankMessage) {
              nextRankMessage.innerHTML = `あと <span class="next-rank-amount">${formatCurrency(remainingAmount)}</span> で ${nextRank} にランクアップ！`;
            }
            
            if (nextRankBenefit && nextRankRate > 0) {
              nextRankBenefit.textContent = `次回の購入で ${nextRankRate}% 還元が適用されます！`;
            }
            
            nextRankElement.style.display = '';
          } else {
            nextRankElement.style.display = 'none';
          }
        } else {
          nextRankElement.style.display = 'none';
        }
      }
      
      // Update data attribute
      cashbackBadge.setAttribute('data-product-price', currentPrice);
    }
  }
  
  // Listen for variant changes (common Shopify events)
  document.addEventListener('DOMContentLoaded', function() {
    updateCashbackAmount();
    
    // Listen for variant change events
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('input_variant') || 
          e.target.closest('.sp-swatches-container') ||
          e.target.closest('.product-size-selector')) {
        setTimeout(updateCashbackAmount, 100);
      }
    });
    
    // Listen for custom variant change events
    document.addEventListener('variant:change', updateCashbackAmount);
    document.addEventListener('productVariantChange', updateCashbackAmount);
    
    // Listen for size selector changes
    document.addEventListener('size:changed', updateCashbackAmount);
  });
  
  // Also update on page load after a delay (for dynamic content)
  window.addEventListener('load', function() {
    setTimeout(updateCashbackAmount, 500);
  });
})();

